'use client'

import { Button } from '@/components/ui/button'
import { BOOKING_SLUG, renderBooking } from '@/lib/infiteq-booking'

let overlay: HTMLDivElement | null = null

function closeBooking() {
  overlay?.remove()
  overlay = null
  document.body.style.removeProperty('overflow')
  document.removeEventListener('keydown', onKeyDown)
}

function onKeyDown(e: KeyboardEvent) {
  if (e.key === 'Escape') closeBooking()
}

/** Opens the Infiteq booking widget in a lightweight modal overlay. */
export function openBooking(slug: string = BOOKING_SLUG) {
  if (typeof window === 'undefined' || overlay) return

  overlay = document.createElement('div')
  overlay.setAttribute('role', 'dialog')
  overlay.setAttribute('aria-modal', 'true')
  overlay.style.cssText =
    'position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(16,20,35,0.45);backdrop-filter:blur(4px);overflow-y:auto;'
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeBooking()
  })

  const wrap = document.createElement('div')
  wrap.style.cssText = 'position:relative;width:100%;max-width:1280px;margin:auto;'

  const close = document.createElement('button')
  close.type = 'button'
  close.setAttribute('aria-label', 'Close')
  close.innerHTML = '&times;'
  close.style.cssText =
    'position:absolute;top:-14px;right:-14px;width:36px;height:36px;display:flex;align-items:center;justify-content:center;border:1px solid #E6E8F0;border-radius:9999px;background:#fff;font-size:22px;line-height:1;color:#5B6178;cursor:pointer;z-index:1;box-shadow:0 4px 12px rgba(16,20,35,0.15);'
  close.addEventListener('click', closeBooking)

  const mount = document.createElement('div')
  mount.style.minWidth = '320px'

  wrap.append(close, mount)
  overlay.appendChild(wrap)
  document.body.appendChild(overlay)
  document.body.style.overflow = 'hidden'
  document.addEventListener('keydown', onKeyDown)

  void renderBooking(mount, { slug })
}

export function BookingButton({ children, size = 'lg', variant = 'outline' }: {
  children: React.ReactNode
  size?: 'lg' | 'sm' | 'md'
  variant?: 'outline' | 'primary'
}) {
  return (
    <Button size={size} variant={variant} onClick={() => openBooking()}>
      {children}
    </Button>
  )
}
